<template>
    <AdminFormGroup
        class="admin-time"
        :class="classes"
    >
        <FormLabel
            :text="label"
            class="form-control"
        >
            <div class="admin-time__input">
                <Datepicker
                    v-bind="datePickerBindings"
                    @update:model-value="update"
                />
            </div>

            <FormError :text="error"/>
            <FormHelp :text="helpText"/>
        </FormLabel>
    </AdminFormGroup>
</template>

<script>
import formDateComposable from "@/composables/forms/form-date";
import {v4 as uuidv4} from "uuid";
import {defineAsyncComponent} from "vue";

export default {
    components: {
        Datepicker: defineAsyncComponent(() => import('vue3-date-time-picker')),
    },

    mixins: [{
        props: formDateComposable.props(),
    }],

    setup(props, {emit}) {
        return {
            ...formDateComposable.composables(props, emit)
        }
    },

    data() {
        return {
            datepicker: {
                uid: uuidv4(),
                enableTimePicker: true,
                locale: 'en-GB',
                range: false,
                monthPicker: false,
                timePicker: true,
                textInput: true,
                position: 'left',
                weekStart: 1,
                format: 'HH:mm',
                monthNameFormat: 'long',
                hideInputIcon: true,
                clearable: false,
                closeOnScroll: true,
                autoApply: true,
                closeOnAutoApply: true,
                inputClassName: 'form-control__input',
            }
        }
    },

    computed: {
        datePickerBindings() {
            const options = this.baseComponentBindings;

            Object.keys(options).forEach(key => options[key] === undefined && delete options[key])

            return Object.assign(this.datepicker, options);
        }
    },

    // TODO: Remove when appropriate
    // Needed to suppress a warning currently emitted due to current vue bug
    emits: ['update:modelValue'],
}
</script>
